module.exports = __webpack_public_path__ + "img/crew_logo.056a38de.png";